<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <alert-container :messages="msgs" />
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('preco-prazo') }}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="onFecharModal"    
                    >
                        {{ $t("cancelar") }}
                    </button>
                    <button
                        class="save-btn"
                        type="button"
                        @click="save"
                    >
                        {{ $t("salvar") }}
                    </button>
                </div>
            </div>
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <vs-select
                            :id="generateId(1)"
                            ref="tabPrecoInput"
                            :title="'tabela-preco'"
                            :options="tabPrecos"
                            v-model="precoprazo.tabpreco"
                            :search="loadTabPrecos"
                            :onChange="updateTabPreco"
                            :placeholder="'tabela-preco'"
                            :invalid="isNull(precoprazo.tabpreco)"
                            :loading="loadingTabPreco"
                            required
                        />
                    </div>
                    <div class="column is-6">
                        <vs-select
                            :id="generateId(2)"
                            ref="pacoteInput"
                            :title="'prazo-pagamento'"
                            :options="prazopagtos"
                            v-model="precoprazo.prazopagto"
                            :search="loadPrazoPagto"
                            :onChange="updatePrazoPagto"
                            :placeholder="'prazo-pagamento'"
                            :invalid="isNull(precoprazo.prazopagto)"
                            :loading="loadingPrazoPagto"
                            required
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TabPrecoService from "@/services/vendas/tabpreco/TabPrecoService";
import PrazoPagtoService from "@/services/vendas/prazopagto/PrazoPagtoService";
import AssProdutoPrecoPrazoService from "@/services/vendas/produto/AssProdutoPrecoPrazoService";
import AssProdutoPrecoPrazoValidation from "@/services/validations/vendas/produto/AssProdutoPrecoPrazoValidation";
import Message from "@/models/Message";
import { mapState } from 'vuex';

export default {
    props: {
        idProduto: 0,
    },
    data() {
        return {
            tabprecoService: new TabPrecoService(this.$http, this.$router),
            prazopagtoservice: new PrazoPagtoService(this.$http, this.$router),
            service: new AssProdutoPrecoPrazoService(this.$http, this.$router),
            validation: null,
            isLoading: false,
            msgs: [],
            tabPrecos:[],
            prazopagtos:[],
            isSaving: false,
            loadingPrazoPagto: false,
            loadingTabPreco: false,
            precoprazo: {
                idProduto: 0,
                tabpreco: null,
                prazopagto: null
            }
        };
    },
    created() {
        if(this.selected){
            this.loadAssPacoteProduto()
        }
        this.carregarDados() 
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        carregarDados() {
            this.validation = new AssProdutoPrecoPrazoValidation(this.msgs)

            this.loadPrazoPagto() 
            this.loadTabPrecos()
        },
        save() {
            this.isLoading = true;
            let precoprazoTemp = this.mapOnSave();
            precoprazoTemp = this.mapTosave(precoprazoTemp);
            if(this.validation.validate(precoprazoTemp, this.$refs)){
                this.isSaving = true;
                this.service.save(precoprazoTemp)
                    .then(value => {
                        if (value.content) {
                            let msg = this.$t("msg-save-sucesso-n", { n: this.$t("preco-prazo") });
                            this.msgs.push(new Message("success", msg, true, false));
                            this.onFecharModal(2)
                        } else {
                            if (this.$t(value.message)) {
                                let msgErro = this.$t(value.message);
                                this.msgs.push(new Message("error", msgErro, true, false));
                            } else {
                                this.msgs.push(
                                    new Message("error", "msg-problema-realizar-acao", true, false)
                                );
                            }
                            this.isSaving = false;
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage(new Message('error', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            }else{
                this.isSaving = false;
                this.isLoading = false;
            }
        },
        mapOnSave(){
            return {
                idprazopagto: this.isNull(this.precoprazo.prazopagto) ? null : this.precoprazo.prazopagto.id,
                idtabpreco: this.isNull(this.precoprazo.tabpreco) ? null : this.precoprazo.tabpreco.id,
                idproduto: this.idProduto,
                situacao: 1
            };
        },
        loadTabPrecos() {
            this.loadingTabPreco = true
            this.tabprecoService
                .findAllComboTabPreco(50)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idtabpreco,
                            label: m.descricao,
                        };
                    });
                })
                .then(allTabsPrecos => {
                this.tabPrecos = allTabsPrecos;
                }, 350)
                .finally(() => {
                    this.loadingTabPreco = false
                })
        },
        loadPrazoPagto() {
            this.loadingPrazoPagto = true
            this.prazopagtoservice
                .findAllCombo(50)
                .then((body) => {
                    return body.content.map((m) => {
                        return {
                            id: m.idprazopagto,
                            label: m.descricao,
                        };
                    });
                })
                .then(allprazopgto => {
                this.prazopagtos = allprazopgto;
                }, 350)
                .finally(() => {
                    this.loadingPrazoPagto = false
                })
        },
        updatePrazoPagto(prazopagto) {
            if (prazopagto) {
                this.precoprazo.prazopagto = prazopagto;
            } else {
                this.precoprazo.prazopagto = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        updateTabPreco(tabpreco) {
            if (tabpreco) {
                this.precoprazo.tabpreco = tabpreco;
            } else {
                this.precoprazo.tabpreco = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        onFecharModal(time = 2){
            setTimeout(() => {
                this.$emit('fecharModal',true);
            }, time * 1000 + 50);
        },
        generateId(numberId){
            return this.$route.name+'-produto-'+numberId;
        },

    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
